<mat-card appearance="outlined" class="breadcrumb-card">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
        <mat-list class="breadcrumb-list">

          @for (elem of pathElements; track elem; let first = $first) {
            <mat-list-item
              class="breadcrumb-list-item">
              <span matListItemTitle class="text">{{ elem }}</span>
              @if (!first) {
                <mat-icon matListItemIcon>blank</mat-icon>
              }
            </mat-list-item>
          }

          <mat-list-item class="breadcrumb-list-item active" [routerLink]="path">
            <span matListItemTitle class="text">{{ lastElement }}</span>
            <mat-icon matListItemIcon>keyboard_arrow_right</mat-icon>
          </mat-list-item>

        </mat-list>
      </mat-card-title>
      <ng-container [ngTemplateOutlet]="actions"></ng-container>
    </mat-card-title-group>
  </mat-card-header>

  <mat-card-content>
    &nbsp;
  </mat-card-content>
</mat-card>
